import { ObservableMap } from 'mobx';
import { select } from 'satcheljs/lib/legacy';
import FolderId from 'owa-service/lib/contract/FolderId';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import Folder from '../store/schema/Folder';
import getStore from '../store/store';

export interface GetFullFolderIdState {
    folderTable: ObservableMap<string, Folder>;
}

export default select<GetFullFolderIdState>({
    folderTable: () => getStore().folderTable,
})(function getFullFolderId(
    folderIdOrName: string | DistinguishedFolderIdName,
    state?: GetFullFolderIdState
): FolderId {
    let folderId = folderNameToId(folderIdOrName);
    if (!folderId) {
        // This is a non-distinguished folder
        folderId = folderIdOrName;
    }
    return state.folderTable.get(folderId).FolderId;
});
